import { render } from "./add-label.vue?vue&type=template&id=989da67c"
import script from "./add-label.vue?vue&type=script&lang=js"
export * from "./add-label.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__